export default "__VITE_ASSET__BuSR2ViL__"